export default {
	"goodsType": {
		"keyWordEmptyTips": "Keywords can not be empty ",
		"priority": "priority",
		"code": "type code",
		"defaultTemperatureType": "default temperature control type",
		"defaultTemperatureRange": "default temperature control range",
		"temperatureControlRange": "Temperature Control Range",
		"keyword": "keywords",
		"keywords": "Keyword",
		"itemType": "Item Type",
		"keywordTips": "keywords (enter to add)",
		"addGoodsType": "Add item type",
		"editGoodsType": "Edit Item Type",
		"editGoodsTypeSuccess": "Item Type has been changed",
		"onlyCreateGoodsTypeSelectTips": "Only item types with new status can be selected",
		"onlyEnableGoodsTypeSelectTips": "Only active item types can be selected",
		"itemTypeCode": "Item Type Code",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"description": "Description",
		"enterItemType": "Enter Item Type",
		"enterItemNumber": "Enter Item Number",
		"enterTemperatureType": "Select Temperature Type",
		"enterItemCode": "Enter Item Type Code",
		"enterKeyword": "Enter Keyword",
		"enterDescription": "Enter Description",
		"action": "Action",
		"explainDetailKeywords": "maximum of 10 characters per keywords, Use 'Enter' to add more keyword",
		"keywordIsRequired": "Keyword is required"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/goodsType/goodsType.js